import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { Invoice }                                      from 'Domain/Models';

export const getInvoices = (state: TRootState, filter: null | IFilterProps<Invoice> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<Invoice>;
  }

  return filterObjectStore(state.invoice.entries, filter);
};
